<script>
    import PreviewElement from "./PreviewElement";
    import FaqElement from "../../components/pagesbuilder/elements/FaqElement";

    export default {
        name: "PreviewFaqElement",
        mixins: [
            PreviewElement,
            FaqElement,
        ],
    }
</script>